import { baseApi } from './baseApi';
import { TAG_TYPES } from 'types';

const URL_BRAND = 'sale-orders/:id/cancel-saleorder';

const brandApiService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    updateCancelSaleOrder: builder.mutation<string, { id: string }>({
      query: ({ id }) => ({
        url: `${URL_BRAND.replace(':id', id)}`,
        method: 'PUT',
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: TAG_TYPES.SaleOrder, id },
        { type: TAG_TYPES.SaleOrder, id: 'LIST' },
      ],
    }),
  }),
  overrideExisting: false,
});

export const { useUpdateCancelSaleOrderMutation } = brandApiService;
